
// variable values
export const TRUE_VALUE = "YES";
export const FALSE_VALUE = "NO";
export const NOT_FOUND = "NONE";
export const NOT_LOADED = "INVALID";

// Top level scenes
export const MAIN_NAME = "main";
export const DATA_NAME = "data";

// Sprite types
export const SPRITE_IMAGE = "_IMAGE_";
export const SPRITE_TEXT = "_TEXT_";
export const SPRITE_GRAPHIC = "_GRAPHIC_";
export const SPRITE_GROUP = "_GROUP_";

// Scene states

export const SCENE_LOADED = "_LOADED_";
export const SCENE_SETUP = "_SETUP_";
export const SCENE_READY = "_READY_";
export const SCENE_STOPPED = "_STOPPED_";
export const SCENE_RUNNING = "_RUNNING_";
export const SCENE_PAUSED = "_PAUSED_";
export const SCENE_FINISHED = "_FINISHED_";
export const SCENE_DELETE_ME = "_DELETE_";

// Scene state actions
export const SCENE_MAKE_RUNNABLE = "_RUNNABLE_";
export const SCENE_PAUSE = "_PAUSE_";
export const SCENE_RESUME = "_RESUME_";
export const SCENE_NEXT_STATE = "_NEXT_";
export const SCENE_FINISH = "_FINISH_";

// scaling types
export const SCALE_FIT = "_FIT_";
export const SCALE_STRETCH = "_STRETCH_";
export const SCALE_NONE = "_NONE_";

// StackFrame types
export const STACK_FOR = "_FOR_";
export const STACK_REPEAT = "_REPEAT_";
